import moment from 'moment';
import React, {useEffect, useState} from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import { isValidForm } from '../../../libs/functions';
import {shippingSamples, shippingSamplesDelete} from '../../../libs/services';
import {bin} from 'react-icons-kit/icomoon/bin';
import CircleButton from '../../../components/CircleButton';

const SendingSamplesList = ({waiting, t, history})=>{
    const [list, setList] = useState([]);

    const [search, setSearch] = useState({
        start_date:moment().format('YYYY-MM-DD'),
        end_date:moment().format('YYYY-MM-DD'),
    });

    const handleChange = (e)=>{
        let name = e.target.name;
        let value = e.target.value;

        let variable = search;

        variable = {
            ...variable,
            [name]: value
        };

        setSearch(variable);
    }

    const onSearch = async ()=>{
        if(isValidForm('div.search-form')){
            let hf_id = sessionStorage.getItem('health_facilities_id');
            let response = await shippingSamples(search.start_date, search.end_date, hf_id, waiting);
            if(response){
                setList(response);
            }
        }else{
            swal('Error', 'Campos incompletos', 'error');
        }
    }

    const onDelete = async (id)=>{
        let response = await shippingSamplesDelete(id, waiting);
        if(response){
            onSearch();
        }
    }

    const showModalDelete = (e, id)=>{        
        swal({
			title: '¿Desea eliminar el registro?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, async (isConfirm)=> {
			if (isConfirm) {								
				onDelete(id);
			}
		});
    }

    useEffect(()=>{
        onSearch();
    }, []);

    return(
        <div className="col-xs-12">
            <div className="route">
                <h5 className="title_page" >
                    {sessionStorage.getItem('health_facilities_name')} ->
                    {t('sidebar.nav.laboratory.MAIN')} -> 
                    {'Envio de Muestras -> Listado'}
                </h5>
            </div>
            <div className='col-xs-12 form-group'>
                <div className='col-xs-12 form-group search-form'>
                    <div className='col-xs-12 col-sm-2'>
                        <span className='span-min'>Desde</span>
                        <input type="date" className='form-control input-sm' id="start_date" name="start_date" value={search.start_date} onChange={(e)=>handleChange(e)} required/>
                    </div>
                    <div className='col-xs-12 col-sm-2'>
                        <span className='span-min'>Hasta</span>
                        <input type="date" className='form-control input-sm' id="end_date" name="end_date" value={search.end_date} onChange={(e)=>handleChange(e)} required/>
                    </div>
                    <div className='col-xs-12 col-sm-2' style={{marginTop:20}}>
                        <button className='btn btn-info' onClick={()=>onSearch()}>Buscar</button>
                    </div>
                    <div className='col-xs-12 col-sm-6' style={{marginTop:20, textAlign:'right'}}>
                        <button className='btn btn-info' onClick={()=>history.push('/shipping_samples/new')}>Nuevo</button>
                    </div>
                </div>
                <div className='col-xs-12 form-group'>
                    <table className='table table-responsive table-hover'>
                        <thead>
                            <tr>
                                <th>No. Muestra</th>
                                <th>Fecha</th>
                                <th>Centro Destino</th>
                                <th>Pruebas</th>
                                <th>Usuario</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.map((l, i)=>
                                <tr key={i}>
                                    <td>{l.sample_number}</td>
                                    <td>{moment(l.timestamp).format('DD/MM/YYYY')}</td>
                                    <td>{l.receiving_center}</td>
                                    <td>
                                        {l.tests.map((test)=>test+' - ')}
                                    </td>
                                    <td>{l.shipping_user}</td>
                                    <td>
                                        <CircleButton 
                                            name="Eliminar"
                                            variables={l.id}
                                            action={showModalDelete}
                                            icon={bin}
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default translate('translations')(SendingSamplesList);